import { render, staticRenderFns } from "./GiftCoupon.vue?vue&type=template&id=53830914&scoped=true"
import script from "./GiftCoupon.vue?vue&type=script&lang=ts"
export * from "./GiftCoupon.vue?vue&type=script&lang=ts"
import style0 from "./GiftCoupon.vue?vue&type=style&index=0&id=53830914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53830914",
  null
  
)

export default component.exports